<template>
    <div v-if="!isFilter">
        <el-menu :default-active="defaultPath" class="el-menu-vertical-demo">
            <div v-for="(item, index) in menuItems" :key="index">
                <!--模块过滤-->
                <template v-if="menuShow(item.module)">
                    <el-submenu v-if="item.childs && item.childs.length > 0" :index="index + ''">
                        <!--通知公告-->
                        <template v-if="item.index == 2 && $store.state.doge > 0" slot="title">
                            <el-badge is-dot class="item">
                                <i :class="item.icon" v-if="item.icon"></i>
                                <span>{{ item.title }}</span>
                            </el-badge>
                        </template>
                        <template v-else slot="title">
                            <i :class="item.icon" v-if="item.icon"></i>
                            <span>{{ item.title }}</span>
                        </template>
                        <el-menu-item-group>
                            <template>
                                <el-menu-item v-for="val in item.childs" @click="changeAniState(val.path)"
                                    :key="val.path" :index="val.path">
                                    <el-badge v-if="val.index == '2-4' && $store.state.doge > 0"
                                        :value="$store.state.doge" :max="99" class="item">
                                        <!-- <i :class="val.icon" v-if="val.icon"></i> -->
                                        <i class="sub-i"></i>
                                        <span>{{ val.title }}</span>
                                    </el-badge>
                                    <template v-else>
                                        <!-- <i :class="val.icon" v-if="val.icon"></i> -->
                                         <i class="sub-i"></i>
                                        <span>{{ val.title }}</span>
                                    </template>
                                </el-menu-item>
                            </template>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item @click="changeAniState(item.path)" :index="item.path" v-else>
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </div>
            <template
                v-if="$store.state.userInfo && $store.state.userInfo.schoolid == 1 && $store.state.userInfo.usertype == 1 && $store.state.currentModule == 'jbxxgl'">
                <el-menu-item v-for="item in adminMeunItems" @click="changeAniState(item.path)" :key="item.index"
                    :index="item.path">
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.title }}</span>
                </el-menu-item>
            </template>
        </el-menu>
    </div>
    <div v-else>
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" router>
            <template>
                <el-menu-item v-for="val in fPaths" @click="changeAniState(val.path)" :key="val.path" :index="val.path">
                    <el-badge v-if="val.index == '2-4' && $store.state.doge > 0" :value="$store.state.doge" :max="99"
                        class="item">
                        <i :class="val.icon" v-if="val.icon"></i>
                        <span>{{ val.title }}</span>
                    </el-badge>
                    <template v-else>
                        <i :class="val.icon" v-if="val.icon"></i>
                        <span>{{ val.title }}</span>
                    </template>
                </el-menu-item>
            </template>
        </el-menu>
    </div>
</template>
<script>
export default {
    props: ['isFilter', "defaultPath", "menuItems", "adminMeunItems","fPaths"],
    data() {
        return {
        };
    },
    computed: {
        menuShow() {
            return function (con) {
                let isStudent = this.$store.state.userInfo && this.$store.state.userInfo.usertype == 4,
                    isModule = !con || (con && con == this.$store.state.currentModule);
                return isStudent || isModule;
            };
        },
    },
    methods: {
        changeAniState(path) {
            this.$emit("changeAniState",path);
        },
    },
};
</script>
<style lang="less" scoped>
/deep/ .el-menu {
    background: none;
    border-right: 0;
}

/deep/ .el-menu-item {
    // background: #c4d8f1;
    // color: #4578ed;
    color: #585858;
    font-weight: 600;
    text-align: left;
    padding-left: 20px !important;
}

/deep/.el-scrollbar__wrap {
    overflow-x: hidden;
}

/deep/.el-submenu__title {
    color: #585858;
    // color: #4578ed;
    font-weight: 600;
    text-align: left;
    padding-left: 20px !important;
}

/deep/.el-menu-item.is-active {
    color: #4578ed;
}

/deep/.el-menu-item.is-active i {
    color: #4578ed;
}

/deep/.el-menu-item:focus,
.el-menu-item:hover {
    // background-color: #b7cbe4;
    // background-color: #f0f0f0;
    background-color: unset;
    background-image: linear-gradient(to bottom, #f0f0f0, #f0f0f0); /* 渐变色作为背景图像 */
    background-size: 90%; /* 背景图像的尺寸 */
    background-repeat: no-repeat; /* 防止图像重复 */
    background-position: center; 
}

/deep/ .el-submenu__title:hover {
    background-color: #f0f0f0;
    // background-color: #b7cbe4;
}

/deep/.el-submenu .el-menu-item {
    padding-left: 40px !important;
    height: 44px;
    line-height: 44px;

}

/deep/.el-menu-item-group__title {
    display: none;
}

/deep/.el-menu-item i {
    color: #585858;
    // color: #4578ed;
}

/deep/.el-submenu__title i {
    color: #585858;
    // color: #4578ed;
}

/deep/.el-badge__content.is-fixed {
    top: 8px;
    right: 0px;
}

/deep/ .el-badge__content.is-fixed.is-dot {
    right: -4px;
    top: 16px;
}
.sub-i{    
    width: 7px;
    height: 7px;
    background: #585858;
    display: inline-block;
    border-radius: 50%;
    margin-right: 8px;
}
</style>